module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result25-2301ca6cb9ab3afee9abf7ccfd67751e.png";